<template>
	<table>
        <slot></slot>
    </table>
</template>
<script>
	export default{
		props: ['url', 'options'],

		mounted(){
			this.dataTables();
            $("#"+this.$el.id+"_filter").find('input').addClass('form-control form-control-sm');
		},

		methods: {
			dataTables(){
                $(this.$el).DataTable({
					"order": [[ 0, "desc" ]],
					"processing": true,
                    "serverSide": true,
                    "ajax": this.url,
                    "select": true,
                    "dom": "<'row'<'col-sm-12 col-md-6'l><'col-sm-12 col-md-6'f>>" +"<'row'<'col-sm-12'tr>>" +"<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'p>>",
                    "columns": this.options.columns,
                    "columnDefs": this.options.columnDefs,
                    "language": {
                        "info": "<b>Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros</b>",
                        "search": "Buscar",
                        "lengthMenu": "Mostrar _MENU_ registros",
                        "infoFiltered": "(filtrado de un total de _MAX_ registros)",
                        "paginate": {
                            "next": "Siguiente",
                            "previous": "Anterior",
                        },
                        "lengthMenu": 'Mostrar <select2>'+
                                    '<option value="10">10</option>'+
                                    '<option value="30">30</option>'+
                                    '<option value="-1">Todos</option>'+
                                    '</select2> registros',
                        "loadingRecords": "Cargando...",
                        "processing": '<i class="fa fa-spinner fa-spin fa-3x fa-fw"></i><span class="sr-only">Loading...</span>',
                        "emptyTable": "No se encontraron resultados",
                        "zeroRecords": "No hay coincidencias", 
                        "infoEmpty": "",
                        "infoFiltered": ""
                    }
                });
			}
		}
	}
</script>